module.exports = __webpack_public_path__ + "static/media/LogoSponsor-18.465b9c21.png";